import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Bank  {
    _originalTypeClassName = "zERP.BO.Bank";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Bank.translate = translateService;
}
this.StatementsConfiguration = [];
this.StatementsCheckConfiguration = [];
this.Id = null;
this.Name = null;
this.BIC = null;
this.DIAS = null;
this.Code = null;
this.Url = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
BIC:any;
DIAS:any;
Code:any;
Url:any;
Description:any;
StatementsConfiguration:any;
StatementsCheckConfiguration:any;
static setStatementsConfiguration = ($this, items) => {
                if (items == null) items = [];
                if ($this.StatementsConfiguration == null) $this.StatementsConfiguration = [];

                const copyItems = Common.cloneObject(items);

                while ($this.StatementsConfiguration.length > 0) {
                    Domain.Bank.removeStatementsConfiguration($this, $this.StatementsConfiguration[0]);
                }

                Domain.Bank.addManyStatementsConfiguration($this, copyItems);
            }
static addManyStatementsConfiguration = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Bank.addStatementsConfiguration($this, items[i]);
                }
            }
static addStatementsConfiguration = ($this, item) => {
                if ($this.StatementsConfiguration == null) $this.StatementsConfiguration = [];
                if (item == null || $this.StatementsConfiguration.indexOf(item) > -1) return;
                $this.StatementsConfiguration.push(item);
if (item.Bank != $this) {
Domain.StatementsConfiguration.setBank(item, $this);
}
}
static addRangeStatementsConfiguration = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Bank.addStatementsConfiguration($this, item));
            }
static removeStatementsConfiguration = ($this, item) => {
                if ($this == null || $this.StatementsConfiguration == null || $this.StatementsConfiguration.indexOf(item) === -1) return;
                var _index = $this.StatementsConfiguration.indexOf(item);
                $this.StatementsConfiguration.splice(_index, 1);
item.Bank = null;
}
static clearStatementsConfiguration = ($this) => { $this.StatementsConfiguration = null; }
static setStatementsCheckConfiguration = ($this, items) => {
                if (items == null) items = [];
                if ($this.StatementsCheckConfiguration == null) $this.StatementsCheckConfiguration = [];

                const copyItems = Common.cloneObject(items);

                while ($this.StatementsCheckConfiguration.length > 0) {
                    Domain.Bank.removeStatementsCheckConfiguration($this, $this.StatementsCheckConfiguration[0]);
                }

                Domain.Bank.addManyStatementsCheckConfiguration($this, copyItems);
            }
static addManyStatementsCheckConfiguration = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Bank.addStatementsCheckConfiguration($this, items[i]);
                }
            }
static addStatementsCheckConfiguration = ($this, item) => {
                if ($this.StatementsCheckConfiguration == null) $this.StatementsCheckConfiguration = [];
                if (item == null || $this.StatementsCheckConfiguration.indexOf(item) > -1) return;
                $this.StatementsCheckConfiguration.push(item);
if (item.Bank != $this) {
Domain.StatementsCheckConfiguration.setBank(item, $this);
}
}
static addRangeStatementsCheckConfiguration = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Bank.addStatementsCheckConfiguration($this, item));
            }
static removeStatementsCheckConfiguration = ($this, item) => {
                if ($this == null || $this.StatementsCheckConfiguration == null || $this.StatementsCheckConfiguration.indexOf(item) === -1) return;
                var _index = $this.StatementsCheckConfiguration.indexOf(item);
                $this.StatementsCheckConfiguration.splice(_index, 1);
item.Bank = null;
}
static clearStatementsCheckConfiguration = ($this) => { $this.StatementsCheckConfiguration = null; }

static GetClassName(): any{return "Bank";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}